if (!customElements.get('product-pack-selector')) {
  customElements.define(
    'product-pack-selector',
    class ProductPackSelector extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.inputs = Array.from(this.querySelectorAll('.pack-option__input'));
        this.inputs.forEach((input) => input.addEventListener('change', this.onChange.bind(this)));
        const selectedInput = this.inputs.find((input) => input.checked && !input.disabled);
        if (selectedInput) this.selectPack(selectedInput);
      }

      onChange(event) {
        this.selectPack(event.currentTarget);
      }

      selectPack(input) {
        const variantId = input.dataset.variantId;
        const available = input.dataset.available === 'true';

        this.productInfo.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
          const variantInput = form.querySelector('input[name="id"]');
          const submitButton = form.querySelector('[type="submit"]');
          if (!variantInput || !submitButton) return;

          variantInput.value = variantId;
          variantInput.disabled = !available;
          submitButton.disabled = !available;
          submitButton.toggleAttribute('aria-disabled', !available);
        });

        const price = this.productInfo.querySelector('[id^="price-"] .price');
        if (!price) return;

        const regularPrice = price.querySelector('.price__regular .price-item--regular');
        const saleComparePrice = price.querySelector('.price__sale s.price-item--regular');
        const salePrice = price.querySelector('.price__sale .price-item--sale');
        const onSale = input.dataset.onSale === 'true';

        price.classList.toggle('price--on-sale', onSale);
        if (regularPrice) regularPrice.textContent = input.dataset.displayPrice;
        if (saleComparePrice) saleComparePrice.textContent = input.dataset.comparePrice;
        if (salePrice) salePrice.textContent = input.dataset.displayPrice;
      }
    }
  );
}
